module.exports = __webpack_public_path__ + "static/img/h5-3.e6262de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/h5-3.png
// module id = iXCX
// module chunks = 1